import styled from 'styled-components'
import Arrow from 'static/icons/chevron-down.svg'
import { MEDIA } from 'utils/constants'

const { MOBILE } = MEDIA

export const SchedulingInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 0;
  border-bottom: 1px solid var(--silver);
  position: relative;
  &:first-of-type {
    padding-top: 0;
    gap: 16px;
    flex-wrap: nowrap;
    cursor: pointer;
    ${({ expanded }) => !expanded && 'padding-bottom: 0; border-bottom: none;'}
  }
  &:nth-last-of-type(2) {
    border-bottom: none;
  }
  section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: start;
  }

  h2 {
    color: var(--gray-2);
    font-family: var(--primary-font);
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.2px;
    padding: 0;
    margin: 0;
  }

  p {
      color: var(--gray-4);
      font-family: var(--primary-font);
      font-size: 13px;
      font-weight: 400;
    }
`

export const SchedulingCardTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Description = styled.p`
  width: 100%;
`

export const ImageWrapper = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`
export const Chevron = styled(Arrow)`
  margin-left: auto;
  transition: .2s ease-in-out;
  ${({ expanded }) => expanded && 'transform: rotate(180deg)'};
`
export const ModalInfo = styled.span`
  font-family: var(--secondary-font);
  font-weight: 500;
  display: block;
  font-size: 17px;

  @media screen and ${MOBILE} {
    margin: 15px;
  }
`

export const ModalWarning = styled.span`
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: var(--gray-2);
  display: block;

  @media screen and ${MOBILE} {
    margin: 15px;
  }
`
